<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="My Submissions" subtitle="See your event submissions and their approval status." />
	
	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no submissions found.">

        <app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Status" />
				<app-table-column text="Name" />
				<app-table-column text="Submitted" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.schedule.suggestions.statusName[item.status]" :type="$constants.schedule.suggestions.statusTheme[item.status]" />
					<app-table-cell-text :text="item.name" />
					<app-table-cell-text :text="item.date.created | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

    </app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			endpoint: 'convention/schedule/suggestions',
            layout: '100px auto 200px' 
		}

	},

	methods: {
	
		onEditClick: function(id) {

			console.log(id)
		
			this.$router.push({
				name: 'Convention.Schedule.Suggestion',
				params: {
					id: id
				}
			})
		
		}
	
	}

}

</script>

<style scoped>

</style>